import { Analytics } from './analytics';
import { BulkAddCartService } from '../../models/add_cart/bulk_add_cart_service';
import { AnalyticsItem } from '../../models/analytics/analytics_item';

// "複数商品を一括でカート追加する処理"を使用する画面の種別。
// 今後、新しい画面にAdobeAnalytics対応が適用される時に画面種別をenumに追加していく。
export enum DisplayTypeForBulkAddCart {
  NoImageVariation // 画像無しバリエ
}

// AdobeAnalyticsに送るパラメータの内、画面毎に異なるパラメータを管理するためのオブジェクト。
// 今後、新しい画面にAdobeAnalytics対応が適用される時に各フィールドや引数に設定する値をenumに追加していく。
const adobeParametersPerDisplay = {
  [DisplayTypeForBulkAddCart.NoImageVariation]: {
    linkName: 'CartAddVariationNoImage',
    fName: 'かご追加（バリエーション一覧_画像無し）'
  }
};

export class BulkAddCartAnalytics extends Analytics {
  constructor(displayType?: DisplayTypeForBulkAddCart) {
    super();
    if (displayType === undefined) return;
    BulkAddCartService.BULK_ADD_CART_EVENT.on((data) => {
      this.run(() => {
        const linkAnalyticsData = {
          server: 'club/pc',
          fName: adobeParametersPerDisplay[displayType].fName,
          events: ['scAdd'],
          items: this.toAdobeItems(data.analyticsData.items),
          club: {
            server: 'club/pc',
            prop5: adobeParametersPerDisplay[displayType].fName,
            events: ['scAdd'],
            products: this.toAdobeProducts(data.analyticsData.items)
          }
        };
        window.sc_trackLinkAll(
          linkAnalyticsData,
          data.target,
          'o',
          adobeParametersPerDisplay[displayType].linkName
        );
      });
    });
  }

  private toAdobeItems(items: Array<AnalyticsItem>) {
    return items.map((item) => ({
      category: '',
      productName: item._catalogItemCode,
      quantity: '',
      price: '',
      events: [],
      evars: { medicalMaterialType: item.getMedicalMaterialType() }
    }));
  }

  private toAdobeProducts(items: Array<AnalyticsItem>) {
    return items.map((item) => ({
      category: '',
      productName: item._catalogItemCode,
      quantity: '',
      price: '',
      events: [],
      evars: { eVar79: item.getMedicalMaterialType() }
    }));
  }
}
